(function () {
  // La barra puede aparecer varias veces en la misma pagina (carrito
  // desplegable + popup de notificacion + pagina /cart), asi que este
  // script tambien se repite varias veces. Nos aseguramos de que la
  // logica de "enganchar" eventos solo se ejecute una vez.
  if (window.__wmShippingBarInit) return;
  window.__wmShippingBarInit = true;

  function animateBar(bar) {
    var fill = bar.querySelector('[data-wm-shipping-fill]');
    if (!fill) return;
    // Leemos el valor real desde el atributo estable data-wm-target,
    // NUNCA desde fill.style.width (que se manipula durante la
    // animacion y puede quedar en 0 si esta funcion se ejecuta
    // varias veces casi a la vez sobre el mismo elemento).
    var target = fill.dataset.wmTarget;
    if (target === undefined) return;

    fill.style.transition = 'none';
    fill.style.width = '0%';
    void fill.offsetWidth;
    fill.style.transition = '';
    requestAnimationFrame(function () {
      fill.style.width = target + '%';
    });
  }

  function animateAllBars() {
    document.querySelectorAll('[data-wm-shipping-bar]').forEach(animateBar);
  }

  // El popup "Articulo agregado a tu carrito" (cart-notification) no se
  // recarga por si solo desde el servidor tras el primer producto, asi que
  // pedimos nosotros mismos una version fresca de la barra y sustituimos
  // solo la que esta dentro de ese popup. No tocamos nada mas del popup.
  function refreshNotificationBar() {
    if (typeof routes === 'undefined' || !routes.cart_url) return;

    fetch(routes.cart_url + '?section_id=free-shipping-bar-refresh')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-wm-shipping-bar]');

        var scopes = document.querySelectorAll('#cart-notification, #CartDrawer, #main-cart-items');
        scopes.forEach(function (scope) {
          var old = scope.querySelector('[data-wm-shipping-bar]');
          if (old && fresh) {
            old.replaceWith(fresh.cloneNode(true));
          } else if (old && !fresh) {
            old.remove();
          }
        });

        animateAllBars();
      })
      .catch(function (e) {
        console.error('free-shipping-bar: no se pudo refrescar', e);
      });
  }

  document.addEventListener('DOMContentLoaded', animateAllBars);
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    animateAllBars();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(refreshNotificationBar, 80);
    });
  }
})();